import { faRefresh, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WeeklyDinnerItem as WeeklyDinnerItemType } from "@mjolnerbacken/shared/types/weekly-dinner-item";

import { useWeeklyDinnerItems } from "../hooks/weekly-dinner-items";
import { useLocale } from "../stores/locale";
import { PrimeButton } from "./prime/button";
import { WeeklyDinnerItem } from "./weekly-dinner-item";

export function WeeklyDinner({ className }: { className?: string }) {
  const t = useLocale((state) => state.locale);
  const {
    data: weeklyDinner,
    invalidateQuery: invalidateWeeklyDinner,
    isInvalidating: isInvalidatingWeeklyDinner,
  } = useWeeklyDinnerItems();

  return (
    <div className={className}>
      <h2 className="flex gap-2 text-xl mb-4">
        {t.weeklyDinner.title}
        <PrimeButton
          disabled={isInvalidatingWeeklyDinner}
          icon={
            <FontAwesomeIcon
              icon={faRefresh}
              spin={isInvalidatingWeeklyDinner}
            />
          }
          severity="success"
          size="small"
          onClick={() => {
            (async () => {
              await invalidateWeeklyDinner();
            })();
          }}
        />
      </h2>
      <div className="relative">
        {isInvalidatingWeeklyDinner && (
          <div className="w-full h-full bg-gray-50/70 absolute top-0 left-0 z-1 flex items-center justify-center">
            <FontAwesomeIcon
              pulse
              className="text-gray-500"
              icon={faSpinner}
              size="4x"
            />
          </div>
        )}
        {weeklyDinner && (
          <ul className="space-y-2">
            {sortWeeklyDinner(weeklyDinner).map((item) => (
              <WeeklyDinnerItem key={item.id} item={item} />
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

// Sorting by current weekday first, then by weekday
function sortWeeklyDinner(
  weeklyDinner: WeeklyDinnerItemType[],
): WeeklyDinnerItemType[] {
  const currentDay = new Date().getDay();
  return weeklyDinner.sort((a, b) => {
    const aDay = a.weekday < currentDay ? a.weekday + 7 : a.weekday;
    const bDay = b.weekday < currentDay ? b.weekday + 7 : b.weekday;
    return aDay - bDay;
  });
}
